// src/pages/WaitPage.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { Hourglass } from "react-loader-spinner";

export default function WaitPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const id = setInterval(() => {
      api.get('/gate/check', {
        params: { token: localStorage.getItem('gateToken') },
      }).then(res => {
        if (res.data.status === 'ENTER') {
          localStorage.setItem('gateToken', res.data.token);
          navigate('/');
        }
      });
    }, 2000);

    return () => clearInterval(id);
  }, [navigate]);

  return (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f8f9fa',
    }}
  >
    <Hourglass
      visible={true}
      height="80"
      width="80"
      colors={['#0d6efd', '#adb5bd']}
    />
    <h4 style={{ marginTop: 20 }}>대기 중입니다</h4>
    <p>순서가 되면 자동 입장됩니다</p>
  </div>
);
}
